import { render, staticRenderFns } from "./regionPkg.vue?vue&type=template&id=0b500c91&scoped=true&"
import script from "./regionPkg.vue?vue&type=script&lang=js&"
export * from "./regionPkg.vue?vue&type=script&lang=js&"
import style0 from "./regionPkg.vue?vue&type=style&index=0&id=0b500c91&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b500c91",
  null
  
)

export default component.exports